<template>
  <div class="login-layout-left" >
    <div
    class="login-layout-left-sider"
    :style="{
      flex: `0 0 ${clientWidth}px`,
      maxWidth: `${clientWidth}px`,
      minWidth: `${clientWidth}px`,
      width: `${clientWidth}px`,
      background: getGradientColor(),
    }"
    >
        <img class="login-layout-left-top" src="../../../assets/images/cloud_top@2x.png" />
        <img  v-if="logoUi.bgSrc" class="login-layout-left-middle" :style="{ width: imgWidth + 'px' }"
        :src="logoUi.bgSrc" />
        <img v-else class="login-layout-left-middle" :style="{ width: imgWidth + 'px' }"
        src="../../../assets/images/linggekj_login_img@3x.png" />
        <img class="login-layout-left-bottom" src="../../../assets/images/cloud_bottom@2x.png" />
    </div>
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';

export default {
  name: 'LeftRow',
  data() {
    return {
      logoUi: getLogo(),
      clientWidth: document.body.clientWidth * (750 / 1920),
      imgWidth: (document.body.clientWidth * (750 / 1920)) * (630 / 750),
      // 不同 appId 对应的渐变色配置
      appIdColors: {
        90001: 'linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%)', // 灵格低代码
        70001: 'linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%)', // 租户管理平台
        60001: 'linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%)', // 医装智能采集
        50001: 'linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%)', // 英比翼一体机
        100001: 'linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%)', // 灵播 Live
        200001: 'linear-gradient(146deg, #D6DFFE 0%, #6e15ce 100%)', // 灵播 Live
        300001: 'linear-gradient(146deg, #D6DFFE 0%, #6e15ce 100%)', // cloud，复用 200001 产品行为
      },
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    const _this = this;
    window.onresize = () => (() => {
      _this.clientWidth = document.body.clientWidth * (750 / 1920);
      _this.imgWidth = (document.body.clientWidth * (750 / 1920)) * (630 / 750);
    })();
  },
  methods: {
    getGradientColor() {
      console.log(this.logoUi.appId);

      const appId = this.logoUi.appId || localStorage.getItem('appId');
      return this.appIdColors[appId] || this.appIdColors['90001']; // 默认返回第一个颜色
    },
  },
};
</script>

<style lang="less" scoped>
.login-layout-left {
  position: relative;
  height: 100%;

  &-sider {
    // background: linear-gradient(146deg, #4D4DFF 0%, #0DDEAD 100%);
    height: 100%;
    position: relative;
    min-width: 0;
    transition: all 0.2s;
  }
  &-top {
    position: absolute;
    top: 0%;
    right: 0%;
    width: 32%;
  }

  &-middle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  &-bottom {
    width: 32%;
    position: absolute;
    bottom: 0%;
    left: 0%;
  }
}
</style>
